<div class="gifloader" *ngIf="loader"></div>
<router-outlet *ngIf="!loader"></router-outlet>
